import PageShell from "@/components/PageShell";
import Seo from "@/components/Seo";

export default function Terms() {
  return (
    <>
      <Seo
        title="Terms of Use | Juwai Morning Teer"
        description="Terms of use for Juwai Morning Teer. All content is provided as-is for informational reference only."
        path="/terms"
      />
      <PageShell>
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight text-emerald-950">
          Terms of Use
        </h1>
        <div className="prose prose-sm sm:prose-base max-w-none mt-4 text-slate-700 leading-relaxed">
          <p>
            By using Juwai Morning Teer you agree that all content on this
            website is provided as-is for informational and reference purposes
            only. No warranty is given regarding accuracy, completeness, or
            fitness for a particular purpose.
          </p>
          <p>
            You agree not to use this website in connection with any illegal or
            unauthorised activity. We may update, correct, or remove any
            content at our sole discretion.
          </p>
          <p>
            We reserve the right to modify these terms at any time. Continued
            use of the website after updates constitutes acceptance of the
            revised terms.
          </p>
        </div>
      </PageShell>
    </>
  );
}
